import LoginBackgroundImage from "@/assets/images/wp8390899-dark-red-space-wallpapers.webp";
import MagicLink from "@/components/MagicLink/magicLink.component";
import { clearAllLocFor } from "@/utils/localForageUtils";
import { deleteTokensLocalStorage } from "@/utils/tokenHandler.util";
import { ChangeEvent, useEffect, useState } from "react";

const LoginPage = () => {
  // Checks if magic link is sent
  const [magicLinkSent, setMagicLinkSent] = useState(false);

  // Persisting Email between MagicLink and MFA
  const [email, setEmail] = useState("");

  const handleEmailChange = (e: ChangeEvent<HTMLInputElement>) => {
    setEmail(e.target.value);
  };

  // useEffect that clears local storage on login page
  useEffect(() => {
    localStorage.removeItem("pending_user_email");
    deleteTokensLocalStorage();
    localStorage.clear();

    // clear session storage
    sessionStorage.clear();

    // clear localForage
    clearAllLocFor();
  }, []);

  return (
    <div id={`page_login`} className="bg-primary h-screen w-screen">
      <img
        src={LoginBackgroundImage}
        alt=""
        className="w-full h-full object-cover fixed top-0 left-0 z-0 "
      />
      <div className="container m-auto relative">
        <MagicLink
          handleEmailChange={handleEmailChange}
          email={email}
          setEmail={setEmail}
          magicLinkSent={magicLinkSent}
          setMagicLinkSent={setMagicLinkSent}
        />
      </div>
    </div>
  );
};

export default LoginPage;
